import { InjectionToken } from '@angular/core';
import { Asn660ApiService } from './asn660-api.service';

export const HTTP_ASN660_SERVICE = new InjectionToken<Asn660ApiService>(
  'Asn660ApiService'
);

export const ASN660_PROVIDER = {
  useClass: Asn660ApiService,
  provide: HTTP_ASN660_SERVICE,
};
